import React from "react";
import ReconciliationBankNotesContext from "./ReconciliationBankNotesContext";
import { useState } from "react";
import { formatDate } from "../../../helpers/FormatHelper";
import { useEffect } from "react";
import { getCurrenciesDenominationsByCustomer } from "../../../networking/NetworkingCurrencies";
import AlertBox from "../../shared/AlertBox";
import { getBankNotesReconciliation, searchVaultReconciliation } from "../../../networking/NetworkingBankNotes";
import moment from "moment";
import { getRolesByUsername } from "../../../networking/NetworkingRoles";
import LoadingBox from "../../shared/LoadingBox";
import { DefaultReconciliation } from "../../../networking/NetworkingOrders";
import { GlobalSystemParametersNames } from "../../../../src/constants/GlobalSystemParametersNames";
import dayjs from "dayjs";

const BANKNOTES_ADMIN = 'BankNotesAdmin'
const ReconciliationBankNotesProvider = ({ children }) => {

  const [data, setData] = useState([]);
  const [columnDetails, setColumnDetails] = useState(null);  
  let str_bnSystemDate=localStorage.getItem(GlobalSystemParametersNames.BNSystemDate);
  let bnSystemDate = dayjs(str_bnSystemDate, "YYYY-MM-DD").toDate(); ;
  const [dateReported, setDateReported] = useState(bnSystemDate);
  const [vaultSelected, setVaultSelected] = useState({});
  const [page, setPage] = useState('');
  const [vaultReconciliationRecord, setVaultReconciliationRecord] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const [currencyDenominations, setCurrencyDenominations] = useState([]);
  const [currencyDenominationsFresh, setCurrencyDenominationsFresh] = useState([]);
  const [alertMessage, setAlertMessage] = useState({ show: false, title: '', message: '' })  
  const [confirmationMessage, setConfirmationMessage] = useState({ show: false, title: '', message: '', callback: null, callbackParams: [] })    
  const [isBankNotesAdmin, setIsBankNotesAdmin] = useState(false)  
  const [loading, setLoading] = useState(false)
  const [showDifferences, setShowDifferences] = useState(false)
  const [defaultReconciliation, setDefaultReconciliation] = useState([]) 

  useEffect(() => {    
    const loadCurrencyDenominations = async () => {
      const currenciesResponse = await getCurrenciesDenominationsByCustomer(0)
      console.log('loadCurrencyDenominations ', currenciesResponse)
      if (currenciesResponse && currenciesResponse.currencies) {
        setCurrencyDenominations(currenciesResponse.currencies);
        setCurrencyDenominationsFresh(JSON.parse(JSON.stringify(currenciesResponse.currencies)));
        const currencies = Array.from(
          new Map(
            currenciesResponse.currencies
              .filter(c => Array.isArray(c.Denominations))
              .map(c => [c.CurrencyID, { value: c.CurrencyID, name: c.CurrencyIDName }])
          ).values()
        );
        setCurrencies(currencies);        
      } else {
        setCurrencyDenominations([]);
        setCurrencyDenominationsFresh([]);
        setCurrencies([]);
      }
    };    
    const loadRoles = async () => {
      getRolesByUsername('ForeignExchange', localStorage.getItem('UserName')).then(
        (response) => {
          console.log('loadRoles ', response)
          if (response && Array.isArray(response) && response.map(e => e.toLowerCase()).includes(BANKNOTES_ADMIN.toLowerCase())) {
            setIsBankNotesAdmin(true)
          }
          else {
            setIsBankNotesAdmin(false)
          }
        }
      )
    }
    loadCurrencyDenominations();
    loadRoles();    
  }, []);

  useEffect(() => {
    const loadDefaultReconciliation = async () => {
      const vaultId = vaultReconciliationRecord.VaultReconciliationID > 0 ? vaultReconciliationRecord.VaultID : vaultSelected.id
      const reconciliationQuery = {
        currencies: currencies,
        vaultId: vaultId
      }
      const response = await DefaultReconciliation(reconciliationQuery);
      if (response && response.result) {
        setDefaultReconciliation(response.result || [])
      }
    }
    loadDefaultReconciliation();
  }, [vaultReconciliationRecord, currencies, vaultSelected]);

  const loadVaultReconciliations = async () => {
    const response = await searchVaultReconciliation(0, '', null, dateReported);
    if (Array.isArray(response.result)) {
      setData(response.result);
    } else {
      setData([]);
    }
    if (response && response.columnDetail != null) {
      const _columnDetail = JSON.parse(response.columnDetail);
      setColumnDetails(_columnDetail);
    }    
  };

  useEffect(() => {
    loadVaultReconciliations();
  }, [dateReported])

  const loadVaultReconciliation = async (reconciliationId) => {

    if (!reconciliationId || reconciliationId === 0) {
      clearReconciliationInfo();
      return
    }

    const reconciliationInfo = await getBankNotesReconciliation(reconciliationId)    
    if (reconciliationInfo && reconciliationInfo.VaultReconciliationID > 0) {
      console.log('reconciliationInfo ', reconciliationInfo)      
      setVaultReconciliationRecord(reconciliationInfo)
      setVaultSelected({ id: reconciliationInfo.VaultID, name: reconciliationInfo.VaultName })            
      setShowDifferences(isBankNotesAdmin)
    }
    else {
      clearReconciliationInfo();
    }
  }

  const alreadyReconciliated = () => {
    const record = data.find(r => moment(r.DateReported).isSame(moment(dateReported), 'day') && r.VaultID === Number(vaultSelected.id))
    if (record && record.VaultReconciliationID > 0)
      return record.VaultReconciliationID
    else {
       setShowDifferences(isBankNotesAdmin)
      return 0
    }
  }

  const clearReconciliationInfo = () => {
    console.log('clear reconciliation info')
    setVaultReconciliationRecord({});
    const currenciesReloaded = currencies.map(c => {
      return {
        value: c.value,
        name: c.name
      };
    });
    setCurrencies(currenciesReloaded);
    setCurrencyDenominations(currencyDenominationsFresh);
    setVaultSelected({});
    setShowDifferences(false)
    reload()
  }

  const closeAlertMessage = () => {
    setAlertMessage({ ...alertMessage, show: false, title: '', message: '' })
  }

  const onYesToConfirmationMessage = () => {
    console.log('yes click')
    if (confirmationMessage.callback !== null) {
      confirmationMessage.callback(...confirmationMessage.callbackParams)
      setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callbac: null })
    }
  }

  const reload = () => {
    loadVaultReconciliations();    
  }

  return (
    <ReconciliationBankNotesContext.Provider
      value={{
        data,
        columnDetails,
        dateReported,
        setDateReported,
        vaultSelected,
        setVaultSelected,
        page,
        setPage,
        vaultReconciliationRecord,
        setVaultReconciliationRecord,
        loadVaultReconciliation,
        currencies,
        setCurrencies,
        currencyDenominations,
        setCurrencyDenominations,
        alertMessage,
        setAlertMessage,
        alreadyReconciliated,
        confirmationMessage,
        setConfirmationMessage,
        onYesToConfirmationMessage,
        reload,
        isBankNotesAdmin,        
        setLoading,
        showDifferences,
        defaultReconciliation
      }}
    >
      <LoadingBox loading={loading} />
      {children}
      <AlertBox id="rc-alert-1" type="Ok" open={alertMessage.show} title={alertMessage.title} message={alertMessage.message}
        okClick={closeAlertMessage} onClose={closeAlertMessage} />
      <AlertBox id="rc-confirmMessage" open={confirmationMessage.show} title={confirmationMessage.title} message={confirmationMessage.message} type="Yes/No"
        yesClick={() => onYesToConfirmationMessage()}
        onClose={() => setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callback: null, callbackParams: [] })}
        noClick={() => setConfirmationMessage({ ...confirmationMessage, show: false, title: '', message: '', callback: null, callbackParams: [] })}
      />        
    </ReconciliationBankNotesContext.Provider>
  );
};

export default ReconciliationBankNotesProvider;